<template>
  <section>
    <div class="field">
      <label class="label">Select product</label>
      <div class="select">
        <select  v-model="productId">
          <option v-for="(product, index) in products" :key="index" v-bind:value="product.id">
            {{ product.name }}
          </option>
        </select>
      </div>
    </div>

    <label class="label">Select files to import</label>
      
    <div class="field file has-name">
      <label class="file-label">
        <input class="file-input" type="file" id="changesEnFile" ref="changesEnFile" v-on:change="handleChangesEnUpload()">
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-upload"></i>
          </span>
          <span class="file-label">
            Choose a file with english changes (changes.txt)
          </span>
        </span>
        <span class="file-name">
         {{ enFile.name }}
        </span>
      </label>
    </div>
    <div class="field">
      <div class="file has-name">
        <label class="file-label">
          <input class="file-input" type="file" id="changesRuFile" ref="changesRuFile" v-on:change="handleChangesRuUpload()">
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"></i>
            </span>
            <span class="file-label">
              Choose a file with russian changes (changes.rus)
            </span>
          </span>
          <span class="file-name">
           {{ ruFile.name }}
          </span>
        </label>
      </div>
    </div>

    <div class="field">
      <button class="button is-success" v-on:click="importChanges" >Import</button>
    </div>

    <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>  
  </section>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

export default {
  name: "import-partial",
  components: { Loading },
  props: {},
  data() {
    return {
      enFile: "",
      ruFile: "",
      products: [],
      productId: 1,
      loading: false,
    };
  },

  methods: {
    handleChangesEnUpload() {
      console.log(this.$refs.changesEnFile.files);
      this.enFile = this.$refs.changesEnFile.files[0];
    },
    handleChangesRuUpload() {
      this.ruFile = this.$refs.changesRuFile.files[0];
    },

    importChanges() {
      this.loading = true;
      let formData = new FormData();
      formData.append("engChangesTextFile", this.enFile);
      formData.append("rusChangesTextFile", this.ruFile);

      this.HTTP.post(
        "Changes/product/fromTxt/" + this.productId,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      )
        .then(response => {
          this.loading = false;
        })
        .catch(ex => {
          console.log(ex);
        });
    },

    getProducts() {
      return new Promise((resolve, reject) => {
        this.HTTP.get("products/" + 1 + "/" + 100)
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  },

  created() {
    this.loading = true;
    this.getProducts().then(data => {
      console.log(data);
      this.products = data.entities;
      if (data.entities != null && data.entities.length > 0)
        this.productId = data.entities[0].id;
      this.loading = false;
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/components/ImportPartial.Vue